import {setElementVisibility} from '@gongxigames/framework/lib/util/htmlUtils';

export function setVisibleStats(visible: boolean): void {
    // TODO move to module Stats
    const stats = document.getElementById('debugStats') as HTMLElement;

    if (stats) {
        if (visible) {
            stats.style.display = 'block';
        } else {
            stats.style.display = 'none';
        }
    }
}

export function setVisibilityStats(visibility: boolean): void {
    setElementVisibility('debugStats', visibility);
}
